<template>
	<div
		:class="context.classes.element"
		:data-type="context.type"
		:data-multiple="attributes && attributes.multiple !== undefined"
	>
		<FormulateSlot
			name="prefix"
			:context="context"
		>
			<component
				:is="context.slotComponents.prefix"
				v-if="context.slotComponents.prefix"
				:context="context"
			/>
		</FormulateSlot>
		<select
			v-model="context.model"
			v-bind="attributes"
			:data-placeholder-selected="placeholderSelected"
			v-on="$listeners"
			@blur="context.blurHandler"
		>
			<option
				v-if="context.placeholder"
				value
				hidden="hidden"
				disabled
				:selected="!hasValue"
			>
				{{ context.placeholder }}
			</option>
			<template
				v-if="!optionGroups"
			>
				<option
					v-for="option in options"
					:key="option.id"
					:value="option.value"
					:disabled="!!option.disabled"
					v-bind="option.attributes || option.attrs || {}"
					v-text="option.label"
				/>
			</template>
			<template
				v-else
			>
				<optgroup
					v-for="(subOptions, label) in optionGroups"
					:key="label"
					:label="label"
				>
					<option
						v-for="option in subOptions"
						:key="option.id"
						:value="option.value"
						:disabled="!!option.disabled"
						v-bind="option.attributes || option.attrs || {}"
						v-text="option.label"
					/>
				</optgroup>
			</template>
		</select>
		<FormulateSlot
			name="suffix"
			:context="context"
		>
			<component
				:is="context.slotComponents.suffix"
				v-if="context.slotComponents.suffix"
				:context="context"
			/>
		</FormulateSlot>
	</div>
</template>

<script>
import {countries} from 'country-data-list';
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";

export default {
    name: "CountryDropdown",
    mixins: [FormulateInputMixin],
    computed: {
        options () {
            return countries.all.filter((country) => {
                return country.status && country.status === 'assigned';
            }).map((country) => {
                return {value: country.alpha2, label: country.name};
            }).sort((a, b) => {
                if (a.label < b.label)  return -1;
                if (a.label > b.label) return 1;
                return 0;
            });
        },
        optionGroups () {
            return this.context.optionGroups || false
        },
        placeholderSelected () {
            return !!(!this.hasValue && this.context.attributes && this.context.attributes.placeholder)
        }
    }
}
</script>
<style scoped>

</style>